import React, { useState, useRef } from "react"
import emailjs from "emailjs-com"

import handPng from "../../assets/img/section-callback/hand.png"
import handWebp from "../../assets/img/section-callback/hand.webp"
import carPng from "../../assets/img/section-callback/car.png"
import carWebp from "../../assets/img/section-callback/car.webp"
import {
  citySwitchTelNumber,
  citySwitchTelNumberCut,
  citySwitchTelNumberStr,
} from "../requisites"

export default function OfferSection({ citySwitch }) {
  const form = useRef()

  const [agreed, setAgreed] = useState(true)
  const [city, setCity] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setMessage] = useState("")

  const sendEmail = e => {
    e.preventDefault()

    emailjs
      .sendForm(
        "service_44gyk98",
        "template_t53r1gx",
        form.current,
        "user_p3PeVrvCFdq6zxN3MjeOj"
      )
      .then(
        result => {
          console.log(result.text)
        },
        error => {
          console.log(error.text)
        }
      )
  }

  return (
    <section className="offer">
      <picture>
        <source srcSet={handWebp} type="image/webp" />
        <source srcSet={handPng} type="image/jpeg" />
        <img
          src={handPng}
          alt="Анализатор катализаторов"
          className="offer-hand-img"
        />
      </picture>
      <div className="container">
        <picture>
          <source srcSet={carWebp} type="image/webp" />
          <source srcSet={carPng} type="image/jpeg" />
          <img
            src={carPng}
            alt="Автомобиль КаталикАвто"
            className="offer-car-img wow slideInLeft"
            // data-wow-delay="0.0s"
            style={
              {
                // visibility: "visible",
                // animationDelay: "0s",
                // animationName: "slideInLeft",
              }
            }
          />
        </picture>
        <div className="offer-header">
          <div
            className="offer-header__left wow bounceInLeft"
            // data-wow-delay="0.2s"
            style={
              {
                // visibility: "visible",
                // animationDelay: "0.2s",
                // animationName: "bounceInLeft",
              }
            }
          >
            <h2 className="offer-header__title big-title">
              Как сдать <span>катализатор?</span>
            </h2>
            <p className="offer-header__descr">
              Позвоните по указанным контактам или оставьте свой вопрос в форме
              ниже, и наш специалист свяжется с вами в ближайшее время.
            </p>
          </div>
          <div
            className="offer-header__right wow bounceInRight"
            // data-wow-delay="0.2s"
            style={
              {
                // visibility: "visible",
                // animationDelay: "0.2s",
                // animationName: "bounceInRight",
              }
            }
          >
            <div className="offer-header__contact-group">
              <a href="tel:88002506625" className="offer-header__phone">
                8 (800) 250-66-25
              </a>
              <div className="offer-header__small">звонок бесплатный</div>
            </div>
            <div className="offer-header__contact-group">
              <a
                href={`tel:${citySwitchTelNumber(citySwitch)}`}
                className="offer-header__phone"
              >
                {citySwitchTelNumberStr(citySwitch)}
              </a>
              <div className="offer-header__socials flex justify-content-end">
                <a
                  href={`whatsapp://send?phone=${citySwitchTelNumberCut(
                    citySwitch
                  )}`}
                  className="offer-header__social social-icon"
                >
                  <svg
                    height="682pt"
                    viewBox="-23 -21 682 682.66669"
                    width="682pt"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
                      fillRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href={`viber://chat?number=${citySwitchTelNumberCut(
                    citySwitch
                  )}`}
                  className="offer-header__social social-icon"
                >
                  <svg
                    enableBackground="new 0 0 24 24"
                    height="512"
                    viewBox="0 0 24 24"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="#8e24aa">
                      <path d="m23.155 13.893c.716-6.027-.344-9.832-2.256-11.553l.001-.001c-3.086-2.939-13.508-3.374-17.2.132-1.658 1.715-2.242 4.232-2.306 7.348-.064 3.117-.14 8.956 5.301 10.54h.005l-.005 2.419s-.037.98.589 1.177c.716.232 1.04-.223 3.267-2.883 3.724.323 6.584-.417 6.909-.525.752-.252 5.007-.815 5.695-6.654zm-12.237 5.477s-2.357 2.939-3.09 3.702c-.24.248-.503.225-.499-.267 0-.323.018-4.016.018-4.016-4.613-1.322-4.341-6.294-4.291-8.895.05-2.602.526-4.733 1.93-6.168 3.239-3.037 12.376-2.358 14.704-.17 2.846 2.523 1.833 9.651 1.839 9.894-.585 4.874-4.033 5.183-4.667 5.394-.271.09-2.786.737-5.944.526z" />
                      <path d="m12.222 4.297c-.385 0-.385.6 0 .605 2.987.023 5.447 2.105 5.474 5.924 0 .403.59.398.585-.005h-.001c-.032-4.115-2.718-6.501-6.058-6.524z" />
                      <path d="m16.151 10.193c-.009.398.58.417.585.014.049-2.269-1.35-4.138-3.979-4.335-.385-.028-.425.577-.041.605 2.28.173 3.481 1.729 3.435 3.716z" />
                      <path d="m15.521 12.774c-.494-.286-.997-.108-1.205.173l-.435.563c-.221.286-.634.248-.634.248-3.014-.797-3.82-3.951-3.82-3.951s-.037-.427.239-.656l.544-.45c.272-.216.444-.736.167-1.247-.74-1.337-1.237-1.798-1.49-2.152-.266-.333-.666-.408-1.082-.183h-.009c-.865.506-1.812 1.453-1.509 2.428.517 1.028 1.467 4.305 4.495 6.781 1.423 1.171 3.675 2.371 4.631 2.648l.009.014c.942.314 1.858-.67 2.347-1.561v-.007c.217-.431.145-.839-.172-1.106-.562-.548-1.41-1.153-2.076-1.542z" />
                      <path d="m13.169 8.104c.961.056 1.427.558 1.477 1.589.018.403.603.375.585-.028-.064-1.346-.766-2.096-2.03-2.166-.385-.023-.421.582-.032.605z" />
                    </g>
                  </svg>
                </a>
                <a
                  href="tg://resolve?domain=Andrey_Kaluga"
                  className="offer-header__social social-icon"
                >
                  <svg
                    id="Bold"
                    enableBackground="new 0 0 24 24"
                    height="512"
                    viewBox="0 0 24 24"
                    width="512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m9.417 15.181-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.541-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.431 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="offer-body wow bounceInUp"
          // data-wow-delay="0.2s"
          style={
            {
              // visibility: "visible",
              // animationDelay: "0.2s",
              // animationName: "bounceInUp",
            }
          }
        >
          <form
            ref={form}
            onSubmit={sendEmail}
            className="ajax_form af_example offer-form"
          >
            <div className="offer-form__row">
              <input
                value={city}
                onChange={e => setCity(e.target.value)}
                type="text"
                className="offer-form__input"
                name="city"
                placeholder="Ваш город"
              />
              <input
                value={phone}
                onChange={e => {
                  let digits = e.target.value.replace(/\D/g, "")
                  setPhone(digits)
                }}
                type="text"
                className="offer-form__input"
                name="phone"
                placeholder="Номер телефона"
                required
              />
            </div>
            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Сообщение"
              name="message"
              className="offer-form__input offer-form__textarea"
            />
            <label className="delivery-form__personal">
              <input
                type="checkbox"
                required
                checked={agreed}
                onClick={() => setAgreed(!agreed)}
              />
              <span className="delivery-form__personal-check" />
              <span className="delivery-form__personal-text">
                Я согласен с{" "}
                <a
                  href="https://katalikauto.ru/politika-konfidenczialnosti"
                  className="footer-col-list__link"
                >
                  условиями обработки
                </a>{" "}
                моих персональных данных
              </span>
            </label>
            <div className="offer-form__button-wrap">
              <button
                type="submit"
                className="offer-form__button button button--solid-orange button--shadow-white"
              >
                Отправить
              </button>
            </div>

            <input
              type="hidden"
              name="af_action"
              value="d5c7fee2fddbcbeb4cfc8c462b1bc8b2"
            />
            <input
              type="text"
              name="org"
              value=""
              className="_org"
              style={{
                visibility: "hidden",
                height: "0",
                width: "0",
                padding: "0",
                border: "none",
              }}
            />
          </form>
        </div>
      </div>
    </section>
  )
}
